import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { useAuth } from './AuthContext';

const TourContext = createContext();

export const useTour = () => {
  const context = useContext(TourContext);
  if (!context) {
    throw new Error('useTour must be used within a TourProvider');
  }
  return context;
};

export const TourProvider = ({ children }) => {
  const { user } = useAuth();
  const [tourActive, setTourActive] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const hasShownTour = useRef(false);

  // Check if user needs onboarding tour - only show ONCE per session on first login
  useEffect(() => {
    if (user && !user.hasCompletedOnboarding && !hasShownTour.current) {
      // Mark that we've shown the tour this session
      hasShownTour.current = true;
      // Start tour automatically after 1 second delay
      const timer = setTimeout(() => {
        setTourActive(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [user]);

  const startTour = () => {
    setStepIndex(0);
    setTourActive(true);
  };

  const stopTour = () => {
    setTourActive(false);
  };

  // Reset tour - called from help button to restart the tour
  const resetTour = () => {
    setStepIndex(0);
    setTourActive(true);
  };

  const completeTour = () => {
    setTourActive(false);
  };

  const value = {
    tourActive,
    stepIndex,
    setStepIndex,
    startTour,
    stopTour,
    resetTour,
    completeTour
  };

  return <TourContext.Provider value={value}>{children}</TourContext.Provider>;
};
